import { init } from '@rematch/core';
import createLoadingPlugin from '@rematch/loading';
import authModel from './model/auth.model';
import eventModel from './model/event.model';
import menteesModel from './model/mentees.model';
import profileModel from './model/profile.model';
import preMatchModel from './model/preMatch.model';
import toastModel from './model/toast.model';
import dialogModel from './model/Dialog.model';
import onBoardingModel from './model/onBoarding.model';
import calendarModel from './model/calendar.model';
import progressConnectionModel from './model/progressConnection.model';
import messagesModel from './model/messages.model';
import notificationsModel from './model/notifications.model';
import homeModel from './model/home.model';
import socketModel from './model/socket.model';
import contentProgressModel from './model/contentProgress.model';
import mentorModel from './model/mentor.model';
import promptModel from './model/prompt.model';
import milestoneModel from './model/milestone.model';
import conversationsModel from './model/conversations.model';
import associatedAccountsModel from './model/associatedAccounts.model';
import chatsModel from './model/chats.model';
import chatMessagesModel from './model/chatMessages.model';
import communityModel from './model/community.model';

const loadingPlugin = createLoadingPlugin();

const store = init({
  redux: {
    rootReducers: {
      RESET: (state, action) => {},
    },
  },
  plugins: [loadingPlugin],
  models: {
    associatedAccountsModel,
    authModel,
    calendarModel,
    chatMessagesModel,
    chatsModel,
    communityModel,
    contentProgressModel,
    conversations: conversationsModel,
    dialogModel,
    eventModel,
    homeModel,
    menteesModel,
    mentorModel,
    messagesModel,
    milestoneModel,
    notificationsModel,
    onBoardingModel,
    preMatchModel,
    profileModel,
    progressConnectionModel,
    promptModel,
    socketModel,
    toastModel,
  },
});

export default store;
